import httpClient from "./httpClient";
const getDynamicPivotTable = (filterList) =>
    httpClient.post("/api/getDynamicPivotTable", filterList);
const addViewApi = (vue) => httpClient.post("/api/addView", vue);
const getViewsApi = () => httpClient.get("api/getView");
const getViewByNameApi = (name) => httpClient.get("/api/getViewByName/" + name);
const exportDynamicPivotTable = (filterList) =>
    httpClient.post(
        "/api/exportDynamicPivotTable",
        filterList,
        { responseType: "blob" }
    );
const getMonthsByYearsApi = (years) => httpClient.post("/api/getMonthsByYears", years);
export {
    getDynamicPivotTable,
    addViewApi,
    getViewsApi,
    getViewByNameApi,
    exportDynamicPivotTable,
    getMonthsByYearsApi
};
